import React from 'react';
import { OffboardingAction } from '../../types';

interface ProgressBarProps {
  actions: OffboardingAction[];
  currentIndex: number;
}

/**
 * Barre de progression pendant l'exécution de l'offboarding
 * Montre le pourcentage et l'action en cours
 */
const ProgressBar: React.FC<ProgressBarProps> = ({ actions, currentIndex }) => {
  const completed = actions.filter((a) => ['success', 'error', 'skipped'].includes(a.status)).length;
  const total = actions.length;
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;
  const currentAction = currentIndex >= 0 ? actions[currentIndex] : null;

  return (
    <div className="bg-white border border-ms-gray-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-medium text-ms-gray-700">
          Progression de l'offboarding
        </p>
        <p className="text-sm text-ms-gray-500">
          {completed}/{total} actions ({percentage}%)
        </p>
      </div>

      {/* Barre */}
      <div className="w-full h-2 bg-ms-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-ms-blue rounded-full transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Action en cours */}
      {currentAction && currentAction.status === 'running' && (
        <p className="text-xs text-ms-blue mt-2 flex items-center gap-1.5">
          <svg className="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          {currentAction.label} en cours...
        </p>
      )}

      {/* Résumé final */}
      {percentage === 100 && (
        <div className="flex gap-4 mt-2 text-xs">
          <span className="text-ms-green">
            {actions.filter((a) => a.status === 'success').length} réussi(s)
          </span>
          <span className="text-ms-red">
            {actions.filter((a) => a.status === 'error').length} erreur(s)
          </span>
          <span className="text-ms-gray-400">
            {actions.filter((a) => a.status === 'skipped').length} ignoré(s)
          </span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
